import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { Footer } from "./Footer";
import { SeasonBanner } from "./SeasonBanner";
import { LangToggle } from "./Nav";
import { useLang, INSTAGRAM } from "../lib/i18n";
import { Instagram } from "lucide-react";

export const PageShell = ({ children }) => {
  const { t } = useLang();
  return (
    <div className="min-h-screen bg-[#F6F2EC] flex flex-col" data-testid="page-shell">
      <header className="sticky top-0 z-50 bg-[#F6F2EC]/85 backdrop-blur-xl border-b border-[#ddd4c7]">
        <SeasonBanner />
        <div className="max-w-[1440px] mx-auto px-5 sm:px-10 h-20 flex items-center justify-between gap-4">
          <Link to="/" data-testid="shell-home-link" aria-label="Home"><Logo /></Link>
          <div className="flex items-center gap-5 sm:gap-8">
            <Link to="/shop" data-testid="shell-shop-link" className="hidden sm:inline text-[0.75rem] tracking-[0.16em] uppercase text-[#14110F]/80 hover:text-[#8A6A3A] transition-colors duration-300">Shop</Link>
            <Link to="/blog" data-testid="shell-blog-link" className="hidden sm:inline text-[0.75rem] tracking-[0.16em] uppercase text-[#14110F]/80 hover:text-[#8A6A3A] transition-colors duration-300">Blog</Link>
            <LangToggle id="shell" />
            <a href={INSTAGRAM} target="_blank" rel="noreferrer" aria-label="Instagram" data-testid="shell-instagram-link" className="hidden sm:inline-flex text-[#14110F] hover:text-[#8A6A3A] transition-colors duration-300">
              <Instagram className="w-[18px] h-[18px]" strokeWidth={1.4} />
            </a>
            <Link to="/#booking" data-testid="shell-book-btn" className="rounded-full bg-[#14110F] text-[#F6F2EC] px-5 sm:px-6 py-2.5 text-[0.7rem] tracking-[0.2em] uppercase transition-colors duration-500 hover:bg-[#8A6A3A]">{t.nav.book}</Link>
          </div>
        </div>
      </header>
      <main className="flex-1 px-5 sm:px-10 py-16 sm:py-24">{children}</main>
      <Footer />
    </div>
  );
};
